import { render } from "./Position.vue?vue&type=template&id=e00f1d90&scoped=true&ts=true"
import script from "./Position.vue?vue&type=script&lang=ts"
export * from "./Position.vue?vue&type=script&lang=ts"

import "./Position.vue?vue&type=style&index=0&id=e00f1d90&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00f1d90"]])

export default __exports__